import { Center, Loader } from '@mantine/core';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthProvider';
import { canAccessRoles } from 'shared/utils/route-access';
import type { RoleName } from 'shared/types/auth';
import Forbidden from '../../pages/Forbidden';

interface RoleRouteProps {
  /** Роли, которым раздел открыт. Пустой список — открыт всем авторизованным. */
  roles: RoleName[];
}

/**
 * Layout-маршрут с проверкой роли. Роли берутся из тех же групп, что и в
 * menu.ts: скрытый пункт меню без такого гарда всё равно открывался по прямой
 * ссылке.
 *
 * Суперпользователь проходит всегда — как require_roles на бэкенде.
 */
export default function RoleRoute({ roles }: RoleRouteProps) {
  const { isAuthenticated, isLoading, user } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <Center h="100vh">
        <Loader size="xl" />
      </Center>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  if (!canAccessRoles(user, roles)) {
    return <Forbidden />;
  }

  return <Outlet />;
}
